"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.num = exports.u256 = void 0;
const assert_1 = __importDefault(require("assert"));
function u256(value) {
    return { a: 0, b: 0, c: 0, d: value };
}
exports.u256 = u256;
function num(value) {
    (0, assert_1.default)(value.c.toNumber() + value.b.toNumber() + value.a.toNumber() == 0, "The returned value must be number-convertible");
    return value.d.toNumber();
}
exports.num = num;
//# sourceMappingURL=u256-utils.js.map